import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import { Collapse } from 'react-bootstrap'
import scrollToElement from 'scroll-to-element'

const CategoryTitle = styled.div`
  padding: 5px 10px;
  height: 50px;
  display: flex;
  align-items: center;
  color: #5f5f61;
  font-size: 13px;
  background: ${(props) => (props.active ? '#eee' : '#f8f8f8')};
  border-bottom: 1px solid var(--light-gray);
  font-weight: 600;
  cursor: pointer;

  ul ul & {
    padding-left: 30px;
    background: ${(props) => (props.active ? '#e2e2e2' : '#f8f8f8')};
  }
`

const Icon = styled.div`
  margin-right: 10px;
  font-size: 22px;
  width: 35px;
  display: inline-block;
  text-align: center;
`

const Chevron = styled.span`
  margin-left: auto;
  font-size: 12px;
  color: ${(props) =>
    props.active ? 'var(--main-color)' : 'var(--dark-gray)'};
`

const FlatIcon = ({ name }) => <i className={`flaticon-${name}`} />

const CategoryToggle = ({ handleClick, active, title, children, icon }) => {
  const scrollTo = (e) => {
    scrollToElement(e, { offset: -150, duration: 500 })
  }
  return (
    <div>
      <CategoryTitle active={active} onClick={handleClick}>
        {icon && (
          <Icon>
            <FlatIcon name={icon} />
          </Icon>
        )}
        {title}
        <Chevron active={active}>
          <FontAwesome name={`chevron-${active ? 'down' : 'up'}`} />
        </Chevron>
      </CategoryTitle>
      <Collapse
        in={active}
        mountOnEnter
        unmountOnExit
        onEntered={scrollTo}
        timeout={0}
      >
        <div>{children}</div>
      </Collapse>
    </div>
  )
}

export default CategoryToggle
